export default "__VITE_ASSET__BcyyyvXF__"